<template>
  <div class="phy_wrap">
    <!-- <div class="sum_title">风险说明</div> -->
    <new-text v-if="text" :text="text"></new-text>
    <div style="background-color: #fff">
      <div
        v-if="item.length !== 0"
        class="risk"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="risk_top">
          <div>
            <!-- <van-image
              class="imgmy"
              :src="ossUrl + '/' + item.icon + '.png'"
              width="30"
              height="30"
              style="margin-right: 5px"
              :error-icon="ossUrl + '/quanlizi.png'"
            >
            </van-image> -->

            <span>{{ item.name }}</span>
          </div>
          <!-- <NewLevelbar
            v-if="item.status"
            class="risk_status"
            :active-index="item.level"
            :data-list="statuslist"
          /> -->
          <div class="text"  :style="{color:item.level == 3?'#c65f10':'#ff0000'}">
            {{ item.level }}级
          </div>
          <div v-if="item.signs" class="risk_signs">
            {{ item.signs }}
          </div>
        </div>
        <div v-show="item.showCon" class="risk_cont">
          <div class="red_title">概述：</div>
          <div>{{ item.introduction }}</div>
          <div class="red_title">常见症状：</div>
          <div><p v-html="item.performance.join('<br/>')"></p></div>
          <div class="red_title">随访或随诊建议：</div>
          <h3 v-if="item.level == 4 || item.level == 5" style="color:#ff0000">中度异常</h3>
          <h3  v-else style="color:#c65f10">轻度异常：</h3>
          <div><p v-html="item.suggestion.join('<br/>')"></p></div>
          
        </div>
        <div
          class="risk_btn"
          @click="handleContent(item, index)"
        >
          {{ item.btntxt }}
          <img
            :class="item.showCon ? 'rotates' : ''"
            src="../assets/image/down.png"
          />
        </div>
      </div>
    </div>
    <div v-if="list.length == 0" class="nodata risk">
      <p>您当前的免疫力很棒，请继续保持哦~</p>
      <p>温馨提示：坚持好习惯，提高免疫力，让您更健康！</p>
      <p>1、戒烟限酒。</p>
      <p>2、室内常通风，保持空气清新。</p>
      <p>3、适量有氧运动，长期坚持，避免单次过量运动。</p>
      <p>4、饮食清淡丰富，避免过分油腻，细嚼慢咽，切忌暴饮暴食</p>
      <p>5、记得时常给心情放个假，放下压力，快乐是健康最好的守护者</p>
    </div>
  </div>
</template>
<script>
import NewText from "./NewText"
import NewLevelbar from "./NewLevelbar"
import { ossUrl } from "@/config";
export default {
  props: ['list'],
  components: { NewText, NewLevelbar },
  data () {
    return {
      ossUrl,
      defaultImg: require('../assets/image/carotid.png'),
      statuslist: [{ name: '正常', id: 1 },
      { name: '潜在', id: 2 },
      { name: '偏高', id: 3 },
      { name: '较高', id: 4 },
      { name: '极高', id: 5 }],
      marks: this.list.marks,
      badOrg: [],
      text: '当机体的健康平衡态被打破，免疫力会努力修复发生的紊乱，但由于主客观因素的叠加影响，疾病早期的风险会不断增加。健康管理建议根据器官的重要程度、免疫风险等级依次展示，每个器官均包括常见健康风险、实用的健康管理建议。需注意：该评估为功能性评价，不作为临床诊断结论，可作为辅助数据参考，同时客户可结合自身症状咨询专业医生进行有针对性的健康管理。'
    }
  },
  watch: {
    list (curVal, oldVal) {
      
      if (curVal) {
        this.risklist = curVal
      }
    },
  },
  methods: {
    handleContent (e, i) {
      console.log('asdf', i)
      let risklist = this.list;
      if (risklist[i].showCon) {
        risklist[i].btntxt = '查看建议'
      } else {
        risklist[i].btntxt = '收起'
      }
      risklist[i].showCon = !risklist[i].showCon
      console.log('risklist[i].showCon', risklist[i].showCon)
      // this.risklist = risklist
    },
    imgError (item) {
      item.img = require('../assets/image/scancode.png');
    }
  },
  created () {
    // this.badOrg = []
    // this.list.healthy.forEach(e => {
    //   if (e.level >= 3) {
    //     this.badOrg.push(e)
    //   }
    // })
    // this.risklist = this.list
  }
}
</script>
<style lang="scss" scoped>
.phy_wrap {
  background-color: #fff;
}
/* 风险说明 */
.sum_title {
  margin: 25px;
  color: #2e94e5;
  border-left: 3px solid #2e94e5;
  padding-left: 12px;
  font-size: 26px;
  height: 26px;
  line-height: 26px;
  text-align: left;
}
.risk {
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
  width: 650px;
}
.risk_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 30px 0;
  font-size: 34px;
}
.risk_top > div:first-child {
  display: flex;
  align-items: center;
}
.risk_top img {
  width: 42px;
  height: 42px;
  vertical-align: middle;
  margin-right: 16px;
}
.risk_status {
  display: flex;
  width: 350px;
}
.risk_signs {
  background-color: #eb6100;
  color: #fff;
  padding: 8px 10px;
  font-size: 25px;
}
.risk_cont {
  font-size: 28px;
  color: #616161;
  padding: 25px 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.red_title {
  font-size: 28px;
  color: #d30909;
  margin: 25px 0 5px;
  font-weight: bold;
}
.risk_btn {
  font-size: 24px;
  color: #949494;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.risk_btn img {
  width: 21px;
  height: 11px;
  margin-left: 5px;
}
.risk_btn img.rotates {
  transform: rotate(180deg);
}
.nodata {
  position: relative;
  // top: 100px;
  // display: flex;
  width: 640px;
  margin: auto;
  text-align: left;
  padding: 60px 0;
  line-height: 50px;
  p {
    margin-bottom: 20px;
    margin-top: 0;
    &:first-child {
      font-weight: bold;
    }
  }
}
</style>